export class ExternalParameters {
    name: string | undefined;
    return: string | undefined;
    properties: string[] = [];
    rights: string[] = [];
  }
  